<template>
  <div class="app-spacer w-full" :class="`app-spacer--${size}`" />
</template>

<script lang="ts" setup>
  const { size } = defineProps<{ size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>();
</script>

<style lang="postcss">
  .app-spacer {
    &--xs {
      height: var(--spacing-2);

      @media (--screen-lg) {
        height: var(--spacing-4);
      }
    }

    &--sm {
      height: var(--spacing-4);

      @media (--screen-lg) {
        height: var(--spacing-6);
      }
    }

    &--md {
      height: var(--spacing-6);

      @media (--screen-lg) {
        height: var(--spacing-8);
      }
    }

    &--lg {
      height: var(--spacing-8);

      @media (--screen-lg) {
        height: var(--spacing-10);
      }
    }

    &--xl {
      height: var(--spacing-10);

      @media (--screen-lg) {
        height: var(--spacing-12);
      }
    }
  }
</style>
